import { Menu } from "./menu";
import { Status } from "./status";
import { User } from "./user";

export class StatusChangeHistory {
    id?: number;
    menu: Menu = new Menu();
    objectId: number | string;
    oldStatus: Status = new Status();
    newStatus: Status = new Status();
    comment: String = '';
    commentEnglish?: String = '';
    isValid: boolean = true;
    status?: Status = new Status();
    createdAt?: Date = new Date();
    createdUser?: User = new User();
}
